import React, { useEffect } from "react";
import { Stack } from "react-bootstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import BusReceptionList from "./BusReceptionList";
import { HugeiconsIcon } from "@hugeicons/react";
import { RealEstate01FreeIcons } from "@hugeicons/core-free-icons";
import { City03Icon } from "@hugeicons/core-free-icons/index";
import { Container } from "reactstrap";

const CenterReceptionJeddah = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  // Get current source from URL, default to 'nusuk' if not present
  const currentSource = searchParams.get("source") || "campaign";

  const handleTabChange = (key) => {
    setSearchParams({ source: key });
  };

  const tabItems = [
    {
      key: "campaign",
      label: t("FROM_PORTS"),
      icon: <HugeiconsIcon size={14} icon={RealEstate01FreeIcons} />,
    },
    {
      key: "between_cities",
      label: t("BETWEEN_CITIES"),
      icon: <HugeiconsIcon size={14} icon={City03Icon} />,
    },
  ];

  return (
    <Stack gap={3}>
      <PageHeader title={t("CENTER_RECEPTION_MAKKAH_ORGANIZER")} sticky={false} />
      <Container fluid>
        <Tabs
          activeKey={currentSource}
          items={tabItems}
          onChange={handleTabChange}
          className="mb-3"
        />
        <BusReceptionList port="JED" source={currentSource} />
      </Container>
    </Stack>
  );
};

export default CenterReceptionJeddah;
